













































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import { PropertyViewModel } from "@/shared/models/property";
import { Notification } from "../../store/modules/notifications";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import ScrollLoader from "@/components/misc/ScrollLoader.vue";
import NoData from "@/components/misc/NoData.vue";
import * as _ from "lodash";
import { Action, Getter } from "vuex-class";
import VueRouter from "vue-router";
import { DataOptions } from "vuetify";
import { SortableTableHeader } from "../generic-pms-table/SortableTableDirective";
import { PropertyType } from "@/shared/models/propertyType";
import { Category } from "@/shared/models/category";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import PropertyImport from "@/components/property/import/PropertyImport.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
const { isNavigationFailure } = VueRouter;

@Component({
  components: {
    ScrollLoader,
    NoData,
    SortableHeadersTable,
    PropertyImport,
    RequireRole,
  },
})
export default class PropertiesGrid extends Vue {
  @Action("codebooks/refreshPropertyTypes")
  refreshPropertyTypes?: () => Promise<void>;
  @Getter("codebooks/propertyTypes") propertyTypes?: PropertyType[];

  @Action("codebooks/refreshCategories")
  refreshCategories?: () => Promise<void>;
  @Getter("codebooks/categories") categories?: Category[];

  @Getter("language/language") language?: string;

  async created() {
    this.displayBody = this.$refs.displayBody as HTMLElement;
    const promises = [];

    if ((this.propertyTypes?.length ?? 0) === 0 && this.refreshPropertyTypes) {
      promises.push(this.refreshPropertyTypes());
    }
    if ((this.categories?.length ?? 0) === 0 && this.refreshCategories) {
      promises.push(this.refreshCategories());
    }

    await Promise.all(promises);
  }

  isPropertyImportOpen = false;
  loading = false;
  settingsOpen = false;
  propertyTypeTextResourceValues: string[] = [];

  displayBody: HTMLElement | null = null;
  isAvailable = [
    { status: true, name: this.$t("Yes") },
    { status: false, name: this.$t("No") },
  ];

  filters = {
    name: "",
    address: "",
    ownerName: "",
    ownerAddress: "",
    propertyTypes: [] as number[],
    categories: [] as number[],
    availableOnBookingEngine: null as boolean | null,
  };

  headers: SortableTableHeader[] = [
    {
      text: "Property.Name",
      value: "name",
      active: true,
      default: true,
      class: "resize-header header-name-width",
      exportHeaders: [],
    },
    {
      text: "Address",
      value: "address",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Property.Type",
      value: "propertyType",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Property.Category",
      value: "category",
      active: true,
      default: false,
      class: "resize-header header-name-width",
      exportHeaders: [],
    },
    {
      text: "Property.Owner",
      value: "ownerName",
      active: true,
      default: false,
      class: "resize-header header-name-width",
      exportHeaders: [],
    },
    {
      text: "Property.OwnerAddress",
      value: "ownerAddress",
      active: true,
      default: false,
      class: "resize-header header-location-width",
      exportHeaders: [],
    },
    {
      text: "Property.IsAvailableViaBookingEngine",
      value: "isAvailableViaBookingEngine",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
      active: true,
      default: true,
      class: "resize-header",
      exportHeaders: [],
    },
  ];

  options: DataOptions = {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["name"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy[0] == "category"
          ? ["categoryTextResourceKey"]
          : this.options.sortBy[0] == "propertyType"
          ? ["typeTextResourceKey"]
          : this.options.sortBy[0] == "isAvailableViaBookingEngine"
          ? ["isAvailableViaBookingEngine"]
          : this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filtersForParams,
    };
  }

  get filtersForParams() {
    return {
      ...this.filters,
      propertyTypes: this.filters.propertyTypes.join(","),
      categories: this.filters.categories.join(","),
    };
  }

  get sortedPropertyTypes() {
    return (
      this.propertyTypes?.sort((a, b) =>
        this.$t(a.textResourceKey)
          .toString()
          .localeCompare(this.$t(b.textResourceKey).toString(), this.language)
      ) ?? []
    );
  }

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.load();
    }
  }

  rowDoubleClick(e: MouseEvent, { item }: { item: PropertyViewModel }) {
    this.editProperty(item.id);
  }

  properties: ListModel<PropertyViewModel> = {
    count: 0,
    result: [],
  };
  async load(): Promise<ListModel<PropertyViewModel>> {
    this.loading = true;
    return this.axios
      .get<ListModel<PropertyViewModel>>("/properties", {
        params: this.queryParams,
      })
      .then((res) => {
        this.properties = res.data;
        return this.properties;
      })
      .finally(() => (this.loading = false));
  }

  addProperty() {
    this.$router.push({ path: "/properties/new" });
  }

  editProperty(id: number) {
    this.loading = true;
    this.$router.push({ path: `/properties/${id}` }).catch((failure) => {
      if (isNavigationFailure(failure)) {
        this.loading = false;
      }
    });
  }

  togglePublish(value: boolean, id: number) {
    Vue.axios
      .put("/properties/SetPropertyBookingEnginePublishStatus/" + id, {
        id: id,
        isAvailableViaBookingEngine: value,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Property.IsAvailableViaBookingEngineSaveSuccess"),
          timeout: 5000,
        });
      });
  }

  @Action("globalFilters/refreshFilter") refreshFilter?: (
    replace?: boolean
  ) => void;
  deleteProperty(item: PropertyViewModel) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("Property.DeleteConfirmation", { value: item?.name }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deletePropertyConfirm(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deletePropertyConfirm({ id }: { id: number }) {
    Vue.axios
      .delete(`/properties/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Property.DeleteSuccess"),
          timeout: 5000,
        } as Notification);

        if (this.refreshFilter) {
          this.refreshFilter();
        }
      })
      .finally(() => {
        this.load();
      });
  }
}
